import { MenuItem, MenuItemProps } from '@chakra-ui/react'
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons'
import { ItList } from 'types/graphql'

import Icon from 'src/components/widgets/Icon/Icon'
import DialogModal from 'src/components/widgets/Modals/DialogModal/DialogModal'
import { IT_LIST_DELETE_MESSAGE } from 'src/lib/constants'

import useDeleteItListMenuItem from './useDeleteItListMenuItem'

const DeleteItListMenuItem: React.FC<
  {
    itList: Pick<ItList, 'id' | 'status'>
    closeMenu(): void
    onDeleted(): void
    label: string
  } & MenuItemProps
> = ({ itList, onDeleted, closeMenu, label, ...props }) => {
  const { isOpen, onClose, onOpen, onConfirm } = useDeleteItListMenuItem(
    itList,
    onDeleted,
    closeMenu
  )

  const statusMessage =
    IT_LIST_DELETE_MESSAGE[itList.status || 'draft'] ||
    IT_LIST_DELETE_MESSAGE.draft

  return (
    <>
      <MenuItem
        data-testid="overflowMenu-removeButton"
        icon={<Icon icon={faTrashCan} fontSize={16} w="18px" />}
        color="danger"
        onClick={onOpen}
        {...props}
      >
        {label}
      </MenuItem>
      <DialogModal
        text={statusMessage.text}
        title={statusMessage.title}
        icon={faTrashCan}
        submitButtonProps={{
          variant: 'text',
          color: 'danger',
        }}
        buttonLabels={{
          submit: 'Delete',
          close: 'Cancel',
        }}
        onSubmit={onConfirm}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  )
}

export default DeleteItListMenuItem
